document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('.mg-menu-toggle');
  const menu = document.querySelector('#MgMenu');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.classList.toggle('is-open', !open);
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    section.querySelectorAll('[data-variant-radio]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (price) price.textContent = radio.dataset.price;
        const accessory = section.querySelector('[data-whole-home-accessory]');
        if (accessory) accessory.disabled = radio.value !== accessory.dataset.wholeHomeVariant;
        const compare = section.querySelector('[data-product-compare]');
        if (compare) { compare.textContent = radio.dataset.comparePrice || ''; compare.hidden = !radio.dataset.comparePrice; }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });
    if (!select || !price) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (option && option.dataset.price) price.textContent = option.dataset.price;
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const mobile = window.matchMedia('(max-width: 720px)');
  const setDisclosures = () => document.querySelectorAll('.mg-mobile-disclosure').forEach(el => { el.open = !mobile.matches; });
  setDisclosures();
  mobile.addEventListener('change', setDisclosures);
});

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.mg-card-form, .mg-product-form');
  const reset = () => forms.forEach(form => {
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    form.querySelectorAll('[data-cart-submit-label]').forEach(button => {
      button.textContent = button.dataset.cartSubmitLabel;
      button.disabled = false;
      delete button.dataset.cartSubmitLabel;
    });
  });
  forms.forEach(form => form.addEventListener('submit', event => {
    if (form.dataset.submitting === 'true') {
      event.preventDefault();
      return;
    }
    if (event.defaultPrevented) return;
    form.dataset.submitting = 'true';
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('button[type="submit"]').forEach(button => {
      if (button.disabled) return;
      button.dataset.cartSubmitLabel = button.textContent;
      button.textContent = form.dataset.addingLabel;
      button.disabled = true;
    });
  }));
  window.addEventListener('pageshow', reset);
});

document.addEventListener('DOMContentLoaded', () => {
 document.querySelectorAll('[data-gallery-src]').forEach(button => button.addEventListener('click', () => { const gallery=button.closest('.mg-product-gallery'); const main=gallery?.querySelector('.mg-product-main-image'); if(!main) return; main.src=button.dataset.gallerySrc; main.removeAttribute('srcset'); main.alt=button.dataset.galleryAlt || '';  gallery.querySelectorAll('[data-gallery-src]').forEach(item=>item.setAttribute('aria-pressed',String(item===button))); }));
 const menu=document.querySelector('#MgMenu'); const toggle=document.querySelector('.mg-menu-toggle'); if(menu&&toggle){ menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');})); document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.classList.contains('is-open')){menu.classList.remove('is-open');toggle.setAttribute('aria-expanded','false');toggle.focus();}}); }
});
